import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Stethoscope } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function ManagementBlocks() {
  const navigate = useNavigate();

  const managementItems = [
    {
      title: "Manage Doctors",
      description: "View and manage doctor profiles",
      icon: Stethoscope,
      action: () => navigate("/settings?tab=users&filter=doctor"),
      color: "bg-blue-50 text-blue-600"
    },
    {
      title: "Manage Staff",
      description: "View and manage staff members",
      icon: Users,
      action: () => navigate("/settings?tab=users&filter=staff"),
      color: "bg-green-50 text-green-600"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {managementItems.map((item, index) => (
        <Card key={index} className="hover:shadow-md transition-shadow cursor-pointer" onClick={item.action}>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="text-lg">{item.title}</CardTitle>
              <div className={`p-2 rounded-full ${item.color}`}>
                <item.icon className="h-5 w-5" />
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">{item.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
} 